export default __webpack_public_path__ + "media/images/favicon/favicon-180x180-1e71845eea4c621f63c3c94a5add36cd.png";